import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ModifyAccountAction = "MODIFY_ACCOUNT";
const SaveAccountAction = "SAVE_ACCOUNT";
const ListAccountsAction = "LIST_ACCOUNTS";
const ListMerchantsAction = "LIST_MERCHANTS";
const Waiting = "WAITNG_ACCOUNTS";

const initialState = {
    mlist: [],
    list: [],
    nowWainting: false,
    editing: null
};
export const actionCreators = {
    /**
     * 加盟店一覧（代表・一般）を取得します。
   	 *（システム管理者、沖縄ICユーザでログイン時）
     */
    listMerchants: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const mlist = await response.json();
                dispatch({ type: ListMerchantsAction, mlist });
                return mlist;
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 一般加盟店一覧を取得します。
     *（代表加盟店ユーザでログイン時）
     */
    listGeneralMerchants: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list_general`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const mlist = resp.result;
                    dispatch({ type: ListMerchantsAction, mlist });
                    return mlist;
                } else {
                    throw new Error(resp.error_message || '加盟店一覧取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * アカウント一覧を取得します。
     * （指定した加盟店IDに紐づくアカウント一覧を取得）
     */
    listAccounts: (token, merchantId) => async (dispatch) => {
        var routeurl = `api/user/accounts/list`;

        if (merchantId != null) {
            routeurl += `?id=${merchantId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    const list = resp.result;
                    dispatch({ type: ListAccountsAction, list });
                    return list;

                } else {

                    throw new Error(resp.error_message || 'データ取得に失敗しました。');

                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * アカウント情報を編集します。
     */
    modifyAccount: (account) => async (dispatch) => {
        dispatch({ type: ModifyAccountAction, account, nowWainting: false });
    },

    /**
     * アカウントの有効化/無効化。
     */
    setEnable: (token, account, enabled) => async (dispatch) => {
        var routeurl = `api/user/accounts/setEnable`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify({ id: account.id, enabled: enabled})
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveAccountAction, account: resp.result });
                    return resp.result;

                } else {
                    throw new Error(resp.error_message || '登録に失敗しました。');
                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集を保存します。
     */
    save: (token, account) => async (dispatch) => {
        var routeurl = `api/user/accounts`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(account)
            })

            var addNew = false;

            // IDがまだないものは新規登録とみなす
            if (account.id == null || account.id == '') {

                addNew = true;
            }

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveAccountAction, account: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '登録に失敗しました。');

                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, accountId, merchantId) => async (dispatch) => {
        var routeurl = `api/user/accounts/edit`;

        if (accountId != null) {
            // 編集時
            routeurl += `?id=${accountId}`;
        }
        else {
            // 新規時
            routeurl += `?merchantId=${merchantId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    const account = resp.result;
                    dispatch({ type: ModifyAccountAction, account });
                    return account;

                } else {

                    throw new Error(resp.error_message || 'データ取得に失敗しました。');

                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集中のアカウントの所属および権限をロードします。
     */
    loadSelectableOrgAndPermissions: (token, account) => async (dispatch) => {
        const routeurl = `api/user/accounts/selectableOrgAndPermissions?role=${account.role}&merchantId=${account.merchant_id}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                account.selectableOrgs = resp.orgs;
                account.availablePermissionTypes = resp.permissionTypes;
                dispatch({ type: ModifyAccountAction, account });
                return resp;
            } else {
                const resp = await response.json();
                throw new Error(resp.error_message || '登録に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyAccountAction) {
        return {
            ...state,
            editing: action.account,
            nowWainting: action.nowWainting
        };
    }
    // 加盟店リスト
    if (action.type === ListMerchantsAction) {
        return {
            ...state,
            mlist: action.mlist,
            nowWainting: action.nowWainting
        };
    }
    // アカウントリスト
   if (action.type === ListAccountsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === SaveAccountAction) {

        if (action.addNew) {
            // アカウントの新規登録時の場合はリストに追加
            state.list.push(action.account);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.list.findIndex((o) => o.id == action.account.id);
            state.list[idx] = action.account;
        }

        return {
            ...state,
            editing: action.account
        };
    }
    return state;
}